import { createContext } from 'react';

type UserRoles = {
  user: boolean;
  onDemand: boolean;
  support: boolean;
  fiscal: boolean;
};

type UserSession = {
  name: string;
  mail: string;
  token: string;
  roles: string[] | null;
  isRolesReady: boolean;
};

export type UserSessionContextState = {
  isReady: boolean;
  userSession: UserSession | null;
  login: () => void;
  logout: () => void;
};

const UserSessionContext = createContext<UserSessionContextState | undefined>(
  undefined
);

export default UserSessionContext;
